<template>
    <div class="msg-wrapper">
        <div class="msg-placeholder">
            <slot name="assistantImg">
                <img @click="clickAvatar">
            </slot>
            <el-popover v-if="$store.state.appSettings.isDebug" trigger="click" placement="left">
                <!--调试信息-->
                <el-link slot="reference" :underline="false"><i class="el-icon-magic-stick"/></el-link>
                <pre style="font-size:12px; color: #999; max-width: 60em; max-height: 40em; overflow: auto;">{{data.notShowContent || data.content}}</pre>
            </el-popover>
        </div>
        <div class="msg-content-box ai-msg-box">
            <div class="ai-msg">
                <div class="ai-msg-content">
                    <thinking-text v-show="data.thinking"></thinking-text>
                    <v-md-preview v-show="!data.thinking" :text="data.content"></v-md-preview>
                </div>
                <div class="ai-msg-misc flex-center-hori">
                    <div class="misc-content">
                        <div v-if="sourceShow" class="msg-content__source" @click="showSource">原内容出处</div>
                    </div>
                    <div class="misc-control flex-center-hori">
                        <div v-show="showStop" class="stop-generating" v-if="!data.finished" @click="stopGenerating()">
                            <img src="@/theme/images/icons/icon_cancel_outline.svg">停止输出
                        </div>
                        <template v-if="showOperate">
                            <template v-if="showSpeek">
                                <div v-if="!data.nospeech" v-show="data.finished" class="play-control">
                                    <el-tooltip class="item" effect="dark" :content="!speeking ? '播放' : '停止播放'" placement="top" :popper-class="isDark?'show-detail-tooltip show-detail-tooltip-dark':'show-detail-tooltip'">
                                        <i v-if="!speeking" class="ecp-iconfont ecp-icon-circle-play" @click="speekTextFlush(data.content)" />
                                        <i v-else class="ecp-iconfont ecp-icon-stop" @click="speekTextStop()" />
                                    </el-tooltip>
                                </div>
                            </template>
                            <div v-if="!data.nospeech" v-show="data.finished" class="feedback-display">
                                <el-tooltip class="item" effect="dark" content="复制问答" placement="top" :popper-class="isDark?'show-detail-tooltip show-detail-tooltip-dark':'show-detail-tooltip'">
                                    <i class="ecp-iconfont ecp-icon-copy" @click="copyAskAnswer()" />
                                </el-tooltip>
                            </div>
                            <div v-if="data.feedback === 1 || data.feedback === -1" v-show="data.finished" class="feedback-display">
                                <i v-if="data.feedback == 1" class="ecp-iconfont ecp-icon-good good" title="满意" />
                                <i v-if="data.feedback == -1" class="ecp-iconfont ecp-icon-bad bad" title="不满意" />
                            </div>
                            <div v-else v-show="data.finished" class="feedback-control">
                                <el-tooltip class="item" effect="dark" content="解决" placement="top" :popper-class="isDark?'show-detail-tooltip show-detail-tooltip-dark':'show-detail-tooltip'">
                                    <i class="ecp-iconfont ecp-icon-good" @click="sendFeedBack(data, 1)" />
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="未解决" placement="top" :popper-class="isDark?'show-detail-tooltip show-detail-tooltip-dark':'show-detail-tooltip'">
                                    <i class="ecp-iconfont ecp-icon-bad" @click="sendFeedBack(data, -1)" />
                                </el-tooltip>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <div class="msg-placeholder"></div>
        <app-dialog v-if="sourceDialogShow"
                    width="80%"
                    customClass="source-dialog"
                    title="原内容出处"
                    :needFooter="false"
                    @onCancel="handleSourceDialogCancel">
            <!--原文出处页面-->
            <qaTable :searchShow="false"
                     :needGetList="false"
                     :needFormatHeader="needFormatHeader"
                     :qaList="sourceList"
                     :qaHeaderList="sourceHeader"></qaTable>
        </app-dialog>
    </div>
</template>
<script>
import copyToClipboard from 'copy-to-clipboard';

import FeedBackMixin from '@/app/mixins/FeedBackMixin.js';
import SpeekTextMixin from '@/app/mixins/SpeekTextMixin.js';

import MsgChatRespondLogic from './MsgChatRespondLogic.vue';
import thinkingText from '../ui/thinkingText';
import AppDialog from '../ui/AppDialog';
import qaTable from '../ui/_MemFrontendPage/qa-table';

export default {
    name: 'MsgChatRespond',
    mixins: [FeedBackMixin, SpeekTextMixin],
    props: {
        'data': Object,
        'askData': Object,
        'currentKnowledge': Object,
        'showOperate': {
            type: Boolean,
            default: true
        },
        'showSpeek': {
            type: Boolean,
            default: true
        },
        'showStop': {
            type: Boolean,
            default: true
        }
    },
    inject: ['stopGenerating'],
    components: { MsgChatRespondLogic, thinkingText, AppDialog, qaTable },
    watch: {
        data: {
            handler (val) {
                this.sourceShow = !!val.knowledgeSoucre && this.currentKnowledge;
            },
            immediate: true,
            deep: true
        }
    },
    data () {
        return {
            speeking: false,
            sourceShow: false,
            sourceDialogShow: false,
            sourceList: [],
            sourceHeader: [],
            needFormatHeader: false
        };
    },
    computed: {
        isDark () {
            return this.$store.state.appSettings.isDark;
        }
    },
    mounted () {
        // 数字人说话
        this.$bus.$on('digital-human:speek-callback', () => {
            this.speeking = true;
        });

        // 数字人待机
        this.$bus.$on('digital-human:standby-callback', () => {
            this.speeking = false;
        });
    },
    methods: {
        // 原内容出处弹窗展示
        showSource () {
            let knowledgeSource = this.data.knowledgeSoucre;
            this.needFormatHeader = Number(this.currentKnowledge.knowledgeType) !== 1;
            this.sourceHeader = knowledgeSource.header;
            this.sourceList = knowledgeSource.source;
            this.sourceDialogShow = true;
        },
        clickAvatar () {
            this.$bus.$emit('digital-human:toggle', {});
        },
        /**
         * 复制到剪贴板
         */
        copyToClipboard (text) {
            copyToClipboard(text);
            this.$message.success('内容已复制到剪贴板');
        },
        /**
         * 复制问答对
         */
        copyAskAnswer () {
            let str = '';
            if (this.askData) {
                str += '问：\n' + this.askData.content + '\n';
            }
            if (this.data) {
                str += '答：\n' + this.data.content + '\n';
            }
            copyToClipboard(str);
            this.$message.success('问答已复制到剪贴板');
        },
        // 原内容出处弹窗关闭
        handleSourceDialogCancel () {
            this.sourceDialogShow = false;
        }
    },
    beforeDestroy () {
        this.$bus.$off('typingRespond');
    }
};
</script>
<style scoped lang="scss">
.msg-placeholder{
    text-align: center;
    img {
        content: var(--assistant-avatar);
    }
}

.ai-msg {
    box-sizing: border-box;
    width: 100%;
    background: var(--msg-ai-bg);
    border-radius: 8px;
    padding: 10px 16px;

    .ai-msg-content {
        box-sizing: border-box;
        width: 100%;
        padding: 0 0 8px;
        font-size: 16px;
        color: var(--msg-common-text-color);
        line-height: 24px;
        overflow-wrap: break-word;
    }

    .ai-msg-misc {
        box-sizing: border-box;
        width: 100%;
        border-top: 1px solid var(--shortcuts-border);
        padding-top: 12px;
        line-height: 24px;

        .misc-content {
            flex: 1 1 auto;
        }

        .stop-generating {
            font-size: 12px;
            color: var(--msg-common-text-color);
            opacity: 0.4;
            cursor: pointer;
            display: flex;
            align-items: center;

            i {
                font-size: 20px;
                cursor: pointer;
                margin: 0 2px;
            }
        }

        .misc-control {
            flex: 0 0 auto;

            img {
                font-size: 20px;
                cursor: pointer;
                margin: 0 2px;
            }

            i {
                margin: 0 2px;
                margin-top: 0;
                line-height: 22px;
            }
        }
        .play-control,
        .feedback-display,
        .feedback-control {
            flex: 0 0 auto;
            i {
                cursor: pointer;
                font-size: 20px;
                opacity: 0.5;
                &:hover {
                    opacity: 1;
                }
            }
        }

        .feedback-display {
            .good {
                cursor: unset;
                opacity: 1;
                color: #126CFF;
            }
            .bad {
                cursor: unset;
                opacity: 1;
                color: #ff1212;
            }
        }
    }
}
.loading-tips {
    color: rgba(150, 150, 150, 0.65);
    border-bottom: 1px solid rgba(150, 150, 150, 0.65);
    padding: 4px 0;
}
.msg-content__source {
    width: 100%;
    height: 31px;
    border-top: 1px solid var(--border-color15);
    color: var(--font-light-color);
    cursor: pointer;
    color: var(--ant-mentions-text-hover);
}
.v-md-editor-preview--source {
    padding-bottom: 30px;
}
</style>
<style lang="scss">
.source-dialog {
    height: 80%;
}
</style>
